import React from 'react';

import './ModuleBlock.scss';

const getJobPositionName = (jobPosition) => {
  if (jobPosition.company !== null) {
    return `${jobPosition.name} at ${jobPosition.company.name}`;
  }

  return jobPosition.name;
};

export default (props) => {
  return (
    <div>
      {props['module-block-data'].sessions.map(Session => (
        <div className='roadmap-module-block'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='roadmap-module-block__advisor'>
                {(Session.advisor.photo !== null) ? <img src={IMAGECACHELINK + '/' + IMAGESTAGE + '/300x300/' + Session.advisor.photo} alt={`${Session.advisor.first_name} ${Session.advisor.last_name}`}
                  className='roadmap-module-block__advisor-photo' /> : null}
                <p className='roadmap-module-block__advisor-name'>{`${Session.advisor.first_name} ${Session.advisor.last_name}`}</p>
                {Session.advisor.job_positions && Session.advisor.job_positions.length > 0 && (
                  <div>
                    <p className='roadmap-module-block__advisor-job-position'>{getJobPositionName(Session.advisor.job_positions[0])}</p>
                    <div className='roadmap-module-block__advisor-previous-job-position'>Formerly:
                      <ul className='clearfix roadmap-module-block__job-entry'>
                        {Session.advisor.job_positions.slice(1).map(job_position => (
                          <li>{getJobPositionName(job_position)}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='roadmap-module-block__module'>
                {Session.Industry && (
                  <p className='roadmap-module-block__module-industry'>{Session.Industry.name}</p>
                )}
                <p className='roadmap-module-block__module-title'>{props['module-block-data'].module_name || ''}</p>
                <p className='roadmap-module-block__module-description'>{props['module-block-data'].student_goal || ''}</p>
                {(Session.scores_improved && Session.scores_improved.length > 0) && (
                  <div>
                    <p className='roadmap-module-block__improve-your-scores'>Improve your scores in</p>
                    <div className='roadmap-module-block__related-skills' />
                    <ul>
                      {Session.scores_improved.map((score, index) => (
                        <li key={index}>{score.score_name}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/LearningRoadmap/components/ModuleBlock/index.js